import React, { useState, useEffect } from "react";
import { Card, CardContent } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import Moment from "react-moment";
import InfoItem from "../../custom/InfoItem";
import Number from "../../custom/Number";
import { getPreviewFine } from "../../actions";
import { useSelector } from "react-redux";

const FineDisplay = ({ id }) => {
  const currentUser = useSelector((state) => state.user.user.me);
  const [fine, setFine] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      const value = await getPreviewFine(id);
      setFine(value);
    };
    fetchData();
  }, [id]);

  if (fine === null) return <></>;

  return (
    <Card style={{ marginBottom: 16 }}>
      <CardContent>
        <InfoItem
          caption={<FormattedMessage id="app.finishContract.today" />}
          text={
            <Moment
              date={new Date()}
              format="DD/MM/YYYY"
            />
          }
        />
        <InfoItem
          caption={<FormattedMessage id="app.fine.applicable" />}
          text={
            <Number
              value={fine}
              currency="LCT"
              hideValue={currentUser.hideValues}
            />
          }
        />
      </CardContent>
    </Card>
  );
};

export default React.memo(FineDisplay);
